"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenPurchaseDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const GetTokenAvgPriceGroupedLive_1 = __importDefault(require("../../get/GetTokenAvgPriceGroupedLive"));
const GetTokenPriceChangeGroupedLive_1 = __importDefault(require("../../get/GetTokenPriceChangeGroupedLive"));
const Dataset_1 = require("../Dataset");
class TokenPurchaseDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.getPuchasesLive = (token, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['token'],
                fieldValue: [token],
                operator: [interfaces_1.Opr.EQUAL],
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
                startAfter,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getAvgPriceLive = (token) => (0, rxjs_1.from)(GetTokenAvgPriceGroupedLive_1.default.get({
            origin: this.origin,
            dataset: interfaces_1.Dataset.TOKEN,
            setId: token,
            apiKey: this.apiKey,
        })).pipe((0, rxjs_1.switchMap)((inner) => inner), (0, rxjs_1.map)((result) => (result === null || result === void 0 ? void 0 : result.avg) || 0));
        this.getPriceChangeLive = (token) => (0, rxjs_1.from)(GetTokenPriceChangeGroupedLive_1.default.get({
            origin: this.origin,
            dataset: interfaces_1.Dataset.TOKEN,
            setId: token,
            apiKey: this.apiKey,
        })).pipe((0, rxjs_1.switchMap)((inner) => inner), (0, rxjs_1.map)((result) => (result === null || result === void 0 ? void 0 : result.change) || 0));
    }
}
exports.TokenPurchaseDataset = TokenPurchaseDataset;
